'use client';

import { useEffect } from 'react';
import { useApp } from '@/forApp/states/appState/appState';
import styles from './styles.module.css';

export default function GlobalLoader() {
  const { isLoading } = useApp();

  useEffect(() => {
    if (isLoading) {
      // Disable scrolling when loader is active
      document.body.style.overflow = 'hidden';

      const preventClick = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
      };

      document.addEventListener('click', preventClick, true);
      document.addEventListener('mousedown', preventClick, true);
      document.addEventListener('touchstart', preventClick, true);

      return () => {
        document.body.style.overflow = 'auto';
        document.removeEventListener('click', preventClick, true);
        document.removeEventListener('mousedown', preventClick, true);
        document.removeEventListener('touchstart', preventClick, true);
      };
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isLoading]);

  return isLoading ? (
    <div
      className={styles.loaderOverlay}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <div className={styles.loaderContainer}>
        <div className={styles.spinner}></div>
      </div>
    </div>
  ) : null;
}
